import { Inject, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';

import { APP_BASE_HREF } from '@angular/common';
import { catchError, lastValueFrom, Observable, of, timeout } from 'rxjs';
import { dateToText } from '../components/application/global.function';
import {
    IAuthPatientPhone,
    IContract,
    ICreatePatient,
    IDogListForSig,
    IDogSignatureRes,
    IPatientExt,
    ITokenAndPatientId,
    IUser,
} from '../interfaces/patient';
import { HttpNewService } from './application/http-new.service';
import { IHttpRequest } from './application/IHttpRes.interface';
import { CookieConsentService } from './cookie-consent-service';
import { EventService } from './event/event.service';
import { Store } from './store.service';
import { PatientService } from './patient.service';

@Injectable({ providedIn: 'root' })
export class AuthService {
    // public token: string | null;
    // public patientId: number | null;
    public isAccessConfigNeeded = false;
    public accessConfigArray: string[] = [];
    // injector: any;

    // /**
    //  * Генерация сообщений об ошибках
    //  * @param error
    //  * @returns {any}
    //  */
    // private static handleError(error: any): any {
    //     let message = '';

    //     if (!error.json().success) {
    //         if (error.json().data.errorCode === 'WrongLoginData') {
    //             message = 'Неверно указаны имя пользователя или пароль';
    //         }
    //         if (error.json().data.errorCode === 'Exception') {
    //             message =
    //                 'Не удается связаться с сервером, повторите попытку позднее';
    //         }
    //     } else {
    //         message = error.data ? error.data : error.toString();
    //     }
    //     return throwError(() => new Error(message));
    // }

    constructor(
        @Inject(APP_BASE_HREF) public appBaseHref: string,
        private router: Router,
        private httpNew: HttpNewService,
        private eventService: EventService,
        private cookieService: CookieConsentService, // private patientService: PatientService
        private injector: Injector
    ) {
        // const Patient = Store.getCookieData<{
        //     token: string;
        //     patient_id: number;
        // }>();
        // console.log(Patient);
        // if (Patient && Patient.token) {
        //     this.token = Patient.token;
        // } else {
        //     this.token = null;
        // }
        // if (Patient && Patient.patient_id) {
        //     this.patientId = Patient.patient_id;
        // } else {
        //     this.patientId = null;
        // }
    }

    /**
     *
     * @param user
     * @param passwd
     * @returns {Observable<any>}
     */
    // public login$(user: string, passwd: string): Promise<IUser> {
    //     return lastValueFrom(
    //         this.httpNew.post('/api/login', { login: user, passwd: passwd })
    //     )
    //         .then((result) => {
    //             // console.log(result);
    //             let tmp = result;
    //             // if (tmp && tmp.length === 1) {
    //             //     tmp = tmp[0];
    //             // }

    //             if (tmp && tmp.token && tmp.patientid) {
    //                 let r = Object.assign({
    //                     token: tmp.token,
    //                     patientId: tmp.patientid,
    //                 });
    //                 if (tmp.ext) {
    //                     r = Object.assign(r, { ext: tmp.ext });
    //                 }
    //                 // console.log(r);
    //                 return r;
    //             } else {
    //                 return Promise.reject(result);
    //             }
    //         })
    //         .catch((err) => {
    //             // console.log(err);
    //             return Promise.reject(err);
    //         })
    //         .finally(() => {
    //             this.eventService.emit('auth:login');
    //         });
    // }
    storeToken(token: string): void {
        // Example: Store the token in localStorage or a secure cookie
        localStorage.setItem('auth_token', token);
    }
    public login$(user: string, passwd: string): Promise<IUser> {
        return lastValueFrom(
            this.httpNew.post('/api/login', { login: user, passwd: passwd })
        )
            .then((result) => {
                if (result && result.token && result.patientid) {
                    this.storeToken(result.token);

                    // ✅ Lazy access to patientService
                    this.patientService.clearPatientInfo();
                    this.patientService.fetchPatientInfo();

                    return {
                        token: result.token,
                        patientId: result.patientid,
                    };
                } else {
                    return Promise.reject(result);
                }
            })
            .catch((err) => {
                console.error('Login error:', err);
                return Promise.reject(err);
            })
            .finally(() => {
                this.eventService.emit('auth:login');
            });
    }
    private _patientService!: PatientService;
    private get patientService(): PatientService {
        if (!this._patientService) {
            this._patientService = this.injector.get(PatientService);
        }
        return this._patientService;
    }

    // protected redirectTo(uri: string) {
    //     this.router.navigate([uri]);
    // }

    protected redirectTo(uri: string) {
        // Ensure we're not already on the target route
        if (this.router.url !== uri) {
            // For absolute paths, prepend the base href
            if (uri.startsWith('/')) {
                // Use Angular's APP_BASE_HREF to construct the correct URL
                const basePath = this.appBaseHref || '/';
                // Remove trailing slash from base path and leading slash from uri to avoid double slashes
                const fullPath =
                    basePath.endsWith('/') && uri.startsWith('/')
                        ? basePath.slice(0, -1) + uri
                        : basePath + uri;

                this.router.navigate([uri]).catch((err) => {
                    console.error('Navigation error:', err);
                    // Fallback: force browser navigation with correct base path
                    window.location.href = fullPath;
                });
            } else {
                // For relative paths, use router navigation directly
                this.router.navigate([uri]).catch((err) => {
                    console.error('Navigation error:', err);
                    window.location.href = uri;
                });
            }
        }
    }
    // private emitTokenEvent(data: string) {
    //     const event = new CustomEvent(tokenEventName, { detail: data });
    //     console.log(event);
    // }

    public getAccessConfig(patientId: number): Promise<string[]> {
        return lastValueFrom(
            this.httpNew.get('/api/user/access', { patientId: patientId })
        )
            .then((result) => {
                // console.log(result);
                return result;
            })
            .catch((err) => {
                throw err;
            });
    }

    public reg$(
        patient: ICreatePatient
    ): Observable<{ id: number; err_code: number; err_text: string }> {
        if (patient.birthDate) {
            patient.birthDate = dateToText(new Date(patient.birthDate));
        }

        return this.httpNew.post('/api/patient', patient);
    }

    public loginOk$(
        token: string,
        patientId: number,
        ext: IPatientExt[]
    ): boolean {
        // this.token = token;
        // this.patientId = patientId;
        // Записываем токен в хранилище
        // Store.setData('Patient', { token: token, patientId: patientId });

        if (ext && ext[0]) {
            ext.forEach((item) => {
                Store.setData(item.name, { val: item.value });
            });
        }
        return true;
    }

    // /**
    //  * Проверка авторизован ли пользователь в данный момент
    //  * @returns {boolean}
    //  */
    // public isLogged(): boolean {
    //     return this.token != null && this.patientId != null;
    // }

    /**
     * Выход из системы, осуществляется только при выполненной авторизации
     */
    // public logout(): void {
    //     //
    //     this.eventService.emit('auth:logout');
    //     Store.clearAllStore();
    //     this.cookieService.deleteAll();
    //     lastValueFrom(this.serverLogout()).finally(() => {
    //         // if (this.cookieService.checkCookieExists('pa-web_Patient_Local'))
    //         this.cookieService.deleteAll();
    //         this.redirectTo('/login');
    //     });
    //     // this.token = null;
    //     // this.patientId = null;
    // }

    // public logout(): void {
    //     // Emit logout event first
    //     this.eventService.emit('auth:logout');

    //     // Clear all local storage
    //     Store.clearAllStore();

    //     // Enhanced cookie deletion - ensure all variations are covered
    //     const cookieNames = [
    //         'pa-web_Patient',
    //         'pa-web_Patient_Local',
    //         'cookieconsent_status',
    //         'pa-web_Patient=',
    //         'pa-web_Patient_Local=',
    //     ];

    //     cookieNames.forEach((cookieName) => {
    //         // Use the service method
    //         this.cookieService.deleteCookie(cookieName);

    //         // Force deletion via direct document.cookie manipulation with multiple paths/domains
    //         const paths = ['/', '/login', '/home'];
    //         const domains = [
    //             window.location.hostname,
    //             `.${window.location.hostname}`,
    //         ];

    //         paths.forEach((path) => {
    //             domains.forEach((domain) => {
    //                 document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=${path};domain=${domain};`;
    //                 document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=${path};`;
    //             });
    //             document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=${path};`;
    //         });

    //         // Final cleanup without path/domain
    //         document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    //     });

    //     // You can also use deleteAll if you want to delete all cookies:
    //     this.cookieService.deleteAll();

    //     // Server-side logout with proper error handling
    //     const serverLogoutTimeout = this.serverLogout().pipe(
    //         timeout(5000),
    //         catchError(() => of(true))
    //     );

    //     lastValueFrom(serverLogoutTimeout).finally(() => {
    //         // Final redirect to login
    //         this.redirectTo('/login');
    //     });
    // }

    public logout(): void {
        // Always emit logout event first
        this.eventService.emit('auth:logout');

        // Clear all client data immediately
        this.clearClientData();

        // Extra assurance: clear localStorage and sessionStorage
        try {
            localStorage.clear();
            sessionStorage.clear();
        } catch (e) {
            console.warn('Failed to clear storage:', e);
        }

        // Get token before clearing data (needed for server logout)
        const token = this.getTokenFromStorage();

        // If we had a token, try server logout
        if (token) {
            // Server-side logout with timeout
            const serverLogoutTimeout = this.serverLogout().pipe(
                timeout(5000), // 5 second timeout
                catchError(() => of(true)) // Ignore errors
            );

            // Wait for server logout then redirect
            lastValueFrom(serverLogoutTimeout).finally(() => {
                // Extra delay to ensure all cleanup is complete
                setTimeout(() => {
                    // Final forceful redirect
                    this.redirectTo('/login');
                }, 200);
            });
        } else {
            // No token, redirect immediately but with a slight delay
            setTimeout(() => {
                // Final forceful redirect
                this.redirectTo('/login');
            }, 200);
        }
    }

    private clearClientData(): void {
        // Очищаем все локальное хранилище
        Store.clearAllStore();

        // Очищаем все куки
        this.clearAllCookies();

        // Очищаем данные сервиса пациента
        try {
            this.patientService.clearPatientInfo();
        } catch (e) {
            console.warn('Не удалось очистить информацию о пациенте:', e);
        }
    }

    private clearAllCookies(): void {
        const cookieNames = [
            'pa-web_Patient_Local',
            'pa-web_Patient',
            'cookieconsent_status',
            'sessionTokenAuthAriadna',
        ];

        // --- 1. Определяем пути ---
        const basePath = this.appBaseHref?.replace(/\/$/, '') || '';
        const currentPath = window.location.pathname;
        const segments = currentPath.split('/');
        const currentBasePath = '/' + segments.slice(1, -1).join('/'); // /lk/oracle/master

        // Все возможные пути
        const paths = [
            '/',
            '/home',
            '/login',
            '/auth',
            basePath,
            basePath + '/home',
            basePath + '/login',
            currentBasePath,
            currentPath,
            currentBasePath + '/home',
        ].filter(Boolean);

        const domains = [
            '',
            window.location.hostname,
            `.${window.location.hostname}`,
        ];
        const isSecure =
            window.location.protocol === 'https:' ? '; Secure' : '';

        // --- 2. Удаляем каждую куку всеми способами ---
        cookieNames.forEach((name) => {
            // 2.1 Удаляем через наш сервис (с поддержкой path)
            paths.forEach((path) => {
                // console.log(path, cookieNames);

                try {
                    this.cookieService.deleteCookie(name, path);
                } catch (e) {
                    console.warn(
                        `[Cookie] Failed to delete via service: ${name} @ ${path}`,
                        e
                    );
                }
            });

            // 2.2 Прямое удаление через document.cookie
            paths.forEach((path) => {
                domains.forEach((domain) => {
                    const domainPart = domain ? `; domain=${domain}` : '';
                    const pathPart = path ? `; path=${path}` : '; path=/';
                    const expires = '; expires=Thu, 01 Jan 1970 00:00:01 GMT';
                    const sameSite = '; SameSite=Lax';

                    try {
                        // Полная комбинация
                        document.cookie = `${name}=${expires}${pathPart}${domainPart}${sameSite}`;
                        if (isSecure) {
                            document.cookie = `${name}=${expires}${pathPart}${domainPart}${sameSite}${isSecure}`;
                        }
                    } catch (e) {
                        console.warn(
                            `[Cookie] Failed to delete ${name} @ ${path} ${domain}`,
                            e
                        );
                    }
                });
            });

            // 2.3 Финальные попытки
            try {
                document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/`;
                document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT`;
            } catch (e) {
                console.warn(`[Cookie] Final fallback failed for ${name}`, e);
            }
        });

        // --- 3. Удаляем все возможные куки вручную (на всякий случай) ---
        try {
            document.cookie.split(';').forEach((c) => {
                const name = c.trim().split('=')[0];
                if (cookieNames.some((n) => name.startsWith(n))) {
                    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/`;
                    if (basePath) {
                        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=${basePath}`;
                    }
                }
            });
        } catch (e) {
            console.warn('[Cookie] Manual cleanup failed', e);
        }

        // --- 4. Удаляем через deleteAll с путями ---
        try {
            this.cookieService.deleteAll();
            if (basePath) {
                this.cookieService.deleteAll(basePath);
            }
        } catch (e) {
            console.warn('[Cookie] deleteAll failed', e);
        }
    }

    private getTokenFromStorage(): string | null {
        try {
            // Check localStorage
            const localStorageToken = localStorage.getItem('auth_token');
            if (localStorageToken) return localStorageToken;

            // Check cookies with different possible names
            const cookieToken = Store.getTokenFromCookie();
            if (cookieToken) return cookieToken;

            // Check sessionStorage
            const sessionToken = sessionStorage.getItem(
                'sessionTokenAuthAriadna'
            );
            if (sessionToken) return sessionToken;

            // Check document.cookie directly for pa-web_Patient_Local
            const match = document.cookie.match(
                new RegExp('(^| )pa-web_Patient_Local=([^;]+)')
            );
            if (match) return match[2];

            // Check for pa-web_Patient
            const match2 = document.cookie.match(
                new RegExp('(^| )pa-web_Patient=([^;]+)')
            );
            if (match2) return match2[2];
        } catch (e) {
            console.warn('Error getting token:', e);
        }
        return null;
    }

    /**
     * Процедура logout'a на стороне сервера
     * @param token
     * @returns {Observable<boolean>}
     */
    public serverLogout(): Observable<boolean> {
        return this.httpNew.post('/api/logout', null);
    }

    /**
     * Смена пароля
     * @param pOldPassword - Старый пароль
     * @param pNewPassword - Новый пароль
     * @returns {Observable<boolean>}
     */
    public changepw(
        pOldPassword: string,
        pNewPassword: string
    ): Observable<any> {
        return this.httpNew.post('/api/changepw', {
            oldPassword: pOldPassword,
            newPassword: pNewPassword,
        });
    }

    /**
     * Восстановление пароля
     * @param  lastName='' - фамилия
     * @param  firstName='' - имя
     * @param  secondName='' - отчество
     * @param  birthDate='' - дата рождения в формате dd_MM_yyyy
     * @param  email='' - электронная почта
     * @returns {Observable<boolean>}
     */
    public findpatientchangepw(
        pLastName: string,
        pFirstName: string,
        pSecondName: string,
        pBirthDate: string,
        pEmail: string,
        pCaptcha: string,
        pCaptchaSolid: string | undefined
    ): Observable<any> {
        return this.httpNew.post('/api/findpatientchangepw', {
            lastName: pLastName,
            firstName: pFirstName,
            secondName: pSecondName.length < 1 ? null : pSecondName,
            birthDate: pBirthDate,
            email: pEmail,
            captchaValue: pCaptcha,
            captchaId: pCaptchaSolid ? pCaptchaSolid.toString() : null,
        });
    }

    /**
     * Проверка токена на восстановление
     * @param  pToken='' - токен
     * @returns {Observable<boolean>}
     */
    public checktr(pToken: string): Observable<any> {
        return this.httpNew.post('/api/checktr', { token: pToken });
    }

    /**
     * смена пароля пациенту по токену
     * @param  pToken='' - токен
     * @param  pNewpw='' - новый пароль
     * @returns {Observable<boolean>}
     */
    public changepwtoken(pToken: string, pNewpw: string): Observable<any> {
        return this.httpNew.post('/api/changepwtoken', {
            token: pToken,
            newpw: pNewpw,
        });
    }

    /***** Договора  ********/

    /* Список договоров (не подписанных) */
    public getContractList(
        tmp: ITokenAndPatientId
    ): Observable<IDogListForSig[]> {
        //      const url = '/api/patient/' + tmp.patientId + '/contract';  // tomCat
        const url = '/contract/patient/list/sig';
        return this.httpNew.get(url);
    }

    /* Подписать договор */
    public postContract(
        tmp: ITokenAndPatientId,
        templateId: number
    ): Observable<IDogSignatureRes[]> {
        //TomCat      const url = '/api/patient/' + tmp.patientId + '/contract/template/' + templateId;
        /*
            const url = '/contract/template/' + templateId;
            return this.httpNew.post(url , null, tmp.token, true);
    */

        const url = `/contract/sig?patientId=${tmp.patientId}&contractId=${templateId}`;
        return this.httpNew.get(url);
    }

    /* Список подписанных договоров */

    public getContractListToPatient(): Observable<IContract[]> {
        //TomCat      const url = '/api/patient/' + this.patientId + '/contract/sign';
        const url = '/contract/patient/list';
        return this.httpNew.get(url);
    }

    public patientforphone$(
        patient: IAuthPatientPhone,
        captchaId: string | undefined
    ): Observable<IHttpRequest> {
        return new Observable((observer) => {
            return this.httpNew
                .post('/api/patientforphone', { ...patient, captchaId }, true)
                .subscribe(
                    (result) => {
                        observer.next(result);
                    },
                    (err) => {
                        observer.error(err);
                    }
                );
        });
    }

    public loginphone$(p_patientid: number): Observable<boolean> | any {
        let param = {
            patientid: p_patientid,
            // captchaValue: p_captcha,
            // captchaId: p_captchaSolid.toString(),
        };
        return new Observable((observer) => {
            return this.httpNew.post('/api/loginphone', param).subscribe(
                (result) => {
                    if (result && result.token && result.patientid) {
                        let tmp = result;
                        if (tmp && tmp.token && tmp.patientid) {
                            let r = Object.assign({
                                token: tmp.token,
                                patientId: tmp.patientid,
                            });
                            if (tmp.ext) {
                                r = Object.assign(r, { ext: tmp.ext });
                            }
                            observer.next(r);
                        } else {
                            observer.error(false);
                        }
                    } else {
                        observer.error(false);
                    }
                },
                (err) => {
                    observer.error(err);
                }
            );
        });
    }
}
